window.addEventListener('DOMContentLoaded', function(e) {
    
    // Hamburger functionality
    let hamburger = document.querySelector('header .hamburger-wrapper');
    if (hamburger) {
        let startY;

        hamburger.addEventListener('click', function(e) {
            hamburger.classList.toggle('active');
            startY = window.scrollY;
        })
        window.addEventListener('click', function(e) {
            if (!e.target.closest('nav') && !e.target.closest('.hamburger')) {
                hamburger.classList.remove('active');
            }
        })
        window.addEventListener('scroll', function(e) {
            if (Math.abs(window.scrollY - startY) >= 100) {
                hamburger.classList.remove('active');
            }
        })
    }
})